import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const watchTopic = createAction(`${actionKey}/WATCH`, (params, onSuccess)=>({
        params,
        onSuccess
    }));
export const watchTopicSuccess = createAction(`${actionKey}/WATCH_SUCCESS`, (params, response)=>({
        params,
        response
    }));
export const watchTopicFailure = createAction(`${actionKey}/WATCH_FAILURE`, (params)=>({
        params
    }));
export const unwatchTopic = createAction(`${actionKey}/UNWATCH`, (params, onSuccess)=>({
        params,
        onSuccess
    }));
export const unwatchTopicSuccess = createAction(`${actionKey}/UNWATCH_SUCCESS`, (params, response)=>({
        params,
        response
    }));
export const unwatchTopicFailure = createAction(`${actionKey}/UNWATCH_FAILURE`, (params)=>({
        params
    }));
export const suppressTopic = createAction(`${actionKey}/SUPPRESS`, (params, onSuccess)=>({
        params,
        onSuccess
    }));
export const suppressTopicSuccess = createAction(`${actionKey}/SUPPRESS_SUCCESS`, (params, response)=>({
        params,
        response
    }));
export const suppressTopicFailure = createAction(`${actionKey}/SUPPRESS_FAILURE`, (params)=>({
        params
    }));

//# sourceMappingURL=actions.js.map